import moment from 'moment';

export default function genererCritereRechercheParution() {
  return {
    auto: '',
    code: '',
    nomParution: '',
    periodeDateEnvoiCF: {
      dateDebut: null,
      dateFin: null,
    },
    periodeDateEnvoiBAT: {
      dateDebut: null,
      dateFin: null,
    },
    periodeDateRemiseEltTech: {
      dateDebut: null,
      dateFin: null,
    },
    periodeDateParution: {
      dateDebut: moment().startOf('month').toDate(),
      dateFin: null,
    },
    produitsId: [],
    actif: true,
    agencesId: [],
    typesProduitIds: [],
  };
}
